import { connect } from 'react-redux';
import { updateUserConfiguration } from '../actions/profile';
import { getUserConfiguration } from '../reducers/profile';

import ProfileOptionsComponent from '../Components/ProfileOptionsComponent';

export const mapStateToProps = (state) => (
  { userConfiguration: getUserConfiguration(state) }
);

export const mapDispatchToProps = (dispatch) => (
  {
    submitOptions: (config) =>
      dispatch(updateUserConfiguration(config))
  }
);

const ProfileOptionsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileOptionsComponent);

export default ProfileOptionsContainer;


// WEBPACK FOOTER //
// src/Containers/ProfileOptionsContainer.jsx